import React from "react";
import style from "./style.module.scss";

export interface PropTypes {
    children: JSX.Element | JSX.Element[];
}

/*
 * TODO: Rebranding: This component will be deprecated after rebranding.
 */
export const CardFooter: React.FunctionComponent<PropTypes> = (props: PropTypes) => {
    const { children } = props;

    return <div className={style.footer}>{children}</div>;
};

export default CardFooter;
